import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emh-stage-campaign-item__tag-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wb_tag = _resolveComponent("wb-tag")!

  return (_openBlock(), _createBlock(_component_wb_tag, {
    class: "emh-stage-campaign-item__campaign-tag wb-tag",
    variant: "primary"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.campaignTagLabel), 1)
    ]),
    _: 3
  }))
}